import React, { useContext, useEffect, useState } from 'react'
import './style.scss'
// import QuickItems from '../../../components/MyBiye/QuickItems/Index'
import PackegeCard from '../../../components/MyBiye/Package/Index'
import Requests from '../../../utils/Requests/Index'
import { trackMetaEvent } from "../../../utils/Requests/metaTracking";
import GhostPackage from '../../../components/SkeletonLoader/GhostLoader'
import { UserContext } from "../../../utils/context/userContext";
import { useQuery } from '@tanstack/react-query'

const Index = () => {
    const [header] = useState({ headers: { Authorization: "Bearer " + localStorage.getItem('token') } })
    // const [result, setResult] = useState(null)
    // const [isLoading, setLoading] = useState(true)
    let [pageLoad, setPageload] = useState(true)
    const { user } = useContext(UserContext);
    console.log(user);
    
    const getPackages = async () => {
        try {
            // setLoading(true)
            const data = await Requests.Package.Index(header)
            // setResult(data)
            // setLoading(false)
            setPageload(false)
            return data
        } catch (error) {
            setPageload(false)
        }
    }

    const { data, isLoading, isError } = useQuery({
        queryKey: ["packages"],
        queryFn: getPackages,
        retry: false,
        gcTime: 2100000,
        refetchOnWindowFocus: false,
        enabled: Boolean(pageLoad)
    })

    // const fetchData = useCallback(async () => {
    //     setLoading(true)
    //     const data = await Requests.Package.Index(header)
    //     setResult(data)
    //     setLoading(false)
    // }, [header])

    // useEffect(() => {
    //     fetchData()
    // }, [header, fetchData])

  // ============================
  // Meta ViewContent Tracking
  // ============================
  useEffect(() => {

    // Package data এখনো load হয়নি
    if (!data || !data.length) {
      return;
    }

    trackMetaEvent(
      "ViewContent",

      // User data
      {
        email: user?.email,
        phone: user?.phone,
      },

      // Custom data
      {
        content_name: "Matrimonial Packages",
        content_type: "product",
      }
    );

    // console.log(
    //   "Package ViewContent tracked"
    // );

  }, [data, user]);

    if (isLoading || isError) return <GhostPackage />

    return (
        <div className="package-container">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="d-lg-flex">
                            {/* <QuickItems /> */}

                            <div className="flex-fill main-section py-4 pt-lg-0">
                                {data ? (
                                    <div className="row package-grid">
                                        {data.map((item, i) => (
                                            <div className="col-12 col-md-6 col-xl-4" key={item.id || item._id || i}>
                                                <PackegeCard data={item} />
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div>Packages are not available yet!</div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Index;
